import { Routes } from '@angular/router';
import { AuthGuard } from './service/auth/auth.guard';
import { LoginGuard } from './service/auth/login.guard';
import { RoleGuard } from './service/core/role.guard';

// dashboard
import { IndexComponent } from './index';

// layouts
import { AppLayout } from './layouts/app-layout';
import { AuthLayout } from './layouts/auth-layout';

// pages
import { Error404Component } from './pages/error404';

export const routes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [AuthGuard],
        children: [
            // Dashboard
            { 
                path: '', 
                component: IndexComponent,
                canActivate: [RoleGuard],
                data: { title: 'Tableau de bord', roles: ['ADMI', 'UMAS', 'AGEN'] } 
            },

            // FEUILLES DE SOINS - Only ADH version exists
            {
                path: 'feuilles-de-soins/ADH',
                loadChildren: () => import('./fds/fds.module').then((d) => d.FdsModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI', 'UMAS'], permissionModule: 'FDSA' },
            },

            // ENTENTES PREALABLES - Only ADH version exists
            {
                path: 'ententes-prealables/ADH',
                loadChildren: () => import('./ep/ep.module').then((d) => d.EpsModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI', 'UMAS'], permissionModule: 'EPA' },
            },

            // AFFECTION LONGUE DUREE - Only ADH version exists
            {
                path: 'affection-longue-duree/ADH',
                loadChildren: () => import('./ald/ald.module').then((d) => d.AldsModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI', 'UMAS'], permissionModule: 'ALDA' },
            },

            // PRISE EN CHARGE - Both ADH and PTR versions
            {
                path: 'prise-en-charge/ADH',
                loadChildren: () => import('./prise en charge/pec.module').then((d) => d.PecsModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI', 'UMAS'], permissionModule: 'PECA' },
            },
            {
                path: 'prise-en-charge/PTR',
                loadChildren: () => import('./prise en charge/pec.module').then((d) => d.PecsModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI', 'UMAS'], permissionModule: 'PECP' },
            },

            // ADHESION - Both ADH and PTR versions
            {
                path: 'adhesion/ADH',
                loadChildren: () => import('./adhesion/adhesion.module').then((d) => d.AdhesionModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI', 'UMAS'], permissionModule: 'ADHA', title: 'Liste des adhesions' },
            },
            {
                path: 'adhesion/PTR',
                loadChildren: () => import('./adhesion/adhesion.module').then((d) => d.AdhesionModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI', 'UMAS'], permissionModule: 'INFO', title: 'Informations' },
            },

            // RECLAMATIONS - Both ADH and PTR versions
            {
                path: 'reclamations/ADH',
                loadChildren: () => import('./reclamations/reclamations.module').then((d) => d.ReclamationsModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI', 'UMAS'], permissionModule: 'RECA' },
            },
            {
                path: 'reclamations/PTR',
                loadChildren: () => import('./reclamations/reclamations.module').then((d) => d.ReclamationsModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI', 'UMAS'], permissionModule: 'RECP' },
            },

            // DOSSIER HORS CASA
            {
                path: 'dossier-hors-casa',
                loadChildren: () => import('./dhc/dhc.module').then((d) => d.DhcModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI', 'UMAS', 'AGEN'], permissionModule: 'DSHC' },
            },

            // CONFIGURATION ROUTES - Admin only
            {
                path: 'utilisateurs',
                loadChildren: () => import('./utilisateurs/utilisateurs.module').then((d) => d.UtilisateursModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI'], permissionModule: 'UTIL' },
            },
            {
                path: 'adherents',
                loadChildren: () => import('./adherents/adherents.module').then((d) => d.AdherentsModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI', 'UMAS'], permissionModule: 'ADHP' },
            },
            {
                path: 'partenaires',
                loadChildren: () => import('./partenaires/partenaires.module').then((d) => d.PartenairesModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI','UMAS'], permissionModule: 'PART' },
            },
            {
                path: 'configuration',
                loadChildren: () => import('./configuration/configuration.module').then((d) => d.ConfigurationModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI'], permissionModule: 'CONF' },
            },
            {
                path: 'statistiques',
                loadChildren: () => import('./statistiques/statistiques.module').then((d) => d.StatistiquesModule),
                canActivate: [RoleGuard],
                data: { roles: ['ADMI'], permissionModule: 'STAT' },
            },

            // Access Denied page
            {
                path: 'access-denied',
                component: Error404Component,
                data: { title: 'Accès refusé' }
            },
        ],
    },

    {
        path: '',
        component: AuthLayout,
        children: [
            { 
                path: '', 
                canActivate: [LoginGuard], 
                loadChildren: () => import('./auth/auth.module').then((d) => d.AuthModule) 
            },
        ],
    },
    
    {
        path: '**',
        component: AppLayout,
        canActivate: [AuthGuard],
        children: [
            { 
                path: '', 
                component: Error404Component, 
                data: { title: 'Page non trouvée' } 
            },
        ],
    },
];